import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateProduct } from '../../../common/api/clients/product.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useProductUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateProduct,
        onSuccess: () => {
            return queryClient.invalidateQueries({ queryKey: queries.products.pagination._def });
        },
    });
};
